import { render, staticRenderFns } from "./ModalDetalhesDeposito.vue?vue&type=template&id=39d8b354&"
import script from "./ModalDetalhesDeposito.vue?vue&type=script&lang=js&"
export * from "./ModalDetalhesDeposito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports